// Module-level store for the /me `read_only_access` flag, written by
// `useAdminAuth`, so the axios guard in `PrivateAdminPanelInstance` can
// read it outside React context (the `setStoredAdminTimezone` pattern).

let storedAdminReadOnly = false;

export const setStoredAdminReadOnly = (value) => {
  storedAdminReadOnly = value === true;
};

export const getStoredAdminReadOnly = () => storedAdminReadOnly;
